"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class RequestApi extends runtime.BaseAPI {
    /**
     * This method adds participants to a customer request.  **[Permissions](#permissions) required**: Permission to manage participants on the customer request.  Note, participants can be added when creating a customer request using the [request](#api-request-post) resource, by defining the participants in the `requestParticipants` field.
     * Add request participants
     */
    addRequestParticipantsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling addRequestParticipants().');
            }
            if (requestParameters['requestParticipantUpdateDTO'] == null) {
                throw new runtime.RequiredError('requestParticipantUpdateDTO', 'Required parameter "requestParticipantUpdateDTO" was null or undefined when calling addRequestParticipants().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/participant`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.RequestParticipantUpdateDTOToJSON)(requestParameters['requestParticipantUpdateDTO']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOUserDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method adds participants to a customer request.  **[Permissions](#permissions) required**: Permission to manage participants on the customer request.  Note, participants can be added when creating a customer request using the [request](#api-request-post) resource, by defining the participants in the `requestParticipants` field.
     * Add request participants
     */
    addRequestParticipants(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.addRequestParticipantsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method enables a user to **Approve** or **Decline** an approval on a customer request. The approval is assumed to be owned by the user making the call.  **[Permissions](#permissions) required**: User is assigned to the approval request.
     * Answer approval
     */
    answerApprovalRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling answerApproval().');
            }
            if (requestParameters['approvalId'] == null) {
                throw new runtime.RequiredError('approvalId', 'Required parameter "approvalId" was null or undefined when calling answerApproval().');
            }
            if (requestParameters['approvalDecisionRequestDTO'] == null) {
                throw new runtime.RequiredError('approvalDecisionRequestDTO', 'Required parameter "approvalDecisionRequestDTO" was null or undefined when calling answerApproval().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/approval/{approvalId}`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"approvalId"}}`, encodeURIComponent(String(requestParameters['approvalId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ApprovalDecisionRequestDTOToJSON)(requestParameters['approvalDecisionRequestDTO']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApprovalDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method enables a user to **Approve** or **Decline** an approval on a customer request. The approval is assumed to be owned by the user making the call.  **[Permissions](#permissions) required**: User is assigned to the approval request.
     * Answer approval
     */
    answerApproval(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.answerApprovalRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method creates a comment on a customer request using one or more attachment files (uploaded using [servicedeskapi/servicedesk/\\{serviceDeskId\\}/attachTemporaryFile](https://developer.atlassian.com/cloud/jira/service-desk/rest/api-group-servicedesk/#api-rest-servicedeskapi-servicedesk-servicedeskid-attachtemporaryfile-post)), with the visibility set by `public`. See   *  GET [servicedeskapi/request/\\{issueIdOrKey\\}/attachment](./#api-rest-servicedeskapi-request-issueidorkey-attachment-get)  *  GET [servicedeskapi/request/\\{issueIdOrKey\\}/comment/\\{commentId\\}/attachment](./#api-rest-servicedeskapi-request-issueidorkey-comment-commentid-attachment-get)  **[Permissions](#permissions) required**: Permission to add an attachment.  **Request limitations**: Customers can set public visibility only.
     * Create comment with attachment
     */
    createCommentWithAttachmentRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling createCommentWithAttachment().');
            }
            if (requestParameters['attachmentCreateDTO'] == null) {
                throw new runtime.RequiredError('attachmentCreateDTO', 'Required parameter "attachmentCreateDTO" was null or undefined when calling createCommentWithAttachment().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/attachment`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.AttachmentCreateDTOToJSON)(requestParameters['attachmentCreateDTO']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.AttachmentCreateResultDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method creates a comment on a customer request using one or more attachment files (uploaded using [servicedeskapi/servicedesk/\\{serviceDeskId\\}/attachTemporaryFile](https://developer.atlassian.com/cloud/jira/service-desk/rest/api-group-servicedesk/#api-rest-servicedeskapi-servicedesk-servicedeskid-attachtemporaryfile-post)), with the visibility set by `public`. See   *  GET [servicedeskapi/request/\\{issueIdOrKey\\}/attachment](./#api-rest-servicedeskapi-request-issueidorkey-attachment-get)  *  GET [servicedeskapi/request/\\{issueIdOrKey\\}/comment/\\{commentId\\}/attachment](./#api-rest-servicedeskapi-request-issueidorkey-comment-commentid-attachment-get)  **[Permissions](#permissions) required**: Permission to add an attachment.  **Request limitations**: Customers can set public visibility only.
     * Create comment with attachment
     */
    createCommentWithAttachment(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCommentWithAttachmentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method creates a customer request in a service desk.  The JSON request must include the service desk and customer request type, as well as any fields that are required for the request type. A list of the fields required by a customer request type can be obtained using [servicedesk/\\{serviceDeskId\\}/requesttype/\\{requestTypeId\\}/field](#api-servicedesk-serviceDeskId-requesttype-requestTypeId-field-get).  The fields required for a customer request type depend on the user\'s permissions:   *  `raiseOnBehalfOf` is not available to Users who have the customer permission only.  *  `requestParticipants` is not available to Users who have the customer permission only or if the feature is turned off for customers.  `requestFieldValues` is a map of Jira field IDs and their values. See [Field input formats](#fieldformats), for details of each field\'s JSON semantics and the values they can take.  **[Permissions](#permissions) required**: Permission to create requests in the specified service desk.
     * Create customer request
     */
    createCustomerRequestRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['requestCreateDTO'] == null) {
                throw new runtime.RequiredError('requestCreateDTO', 'Required parameter "requestCreateDTO" was null or undefined when calling createCustomerRequest().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.RequestCreateDTOToJSON)(requestParameters['requestCreateDTO']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CustomerRequestDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method creates a customer request in a service desk.  The JSON request must include the service desk and customer request type, as well as any fields that are required for the request type. A list of the fields required by a customer request type can be obtained using [servicedesk/\\{serviceDeskId\\}/requesttype/\\{requestTypeId\\}/field](#api-servicedesk-serviceDeskId-requesttype-requestTypeId-field-get).  The fields required for a customer request type depend on the user\'s permissions:   *  `raiseOnBehalfOf` is not available to Users who have the customer permission only.  *  `requestParticipants` is not available to Users who have the customer permission only or if the feature is turned off for customers.  `requestFieldValues` is a map of Jira field IDs and their values. See [Field input formats](#fieldformats), for details of each field\'s JSON semantics and the values they can take.  **[Permissions](#permissions) required**: Permission to create requests in the specified service desk.
     * Create customer request
     */
    createCustomerRequest(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.createCustomerRequestRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method creates a public or private (internal) comment on a customer request, with the comment visibility set by `public`. The user recorded as the author of the comment.  **[Permissions](#permissions) required**: User has Add Comments permission.  **Request limitations**: Customers can set comments to public visibility only.
     * Create request comment
     */
    createRequestCommentRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling createRequestComment().');
            }
            if (requestParameters['commentCreateDTO'] == null) {
                throw new runtime.RequiredError('commentCreateDTO', 'Required parameter "commentCreateDTO" was null or undefined when calling createRequestComment().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/comment`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.CommentCreateDTOToJSON)(requestParameters['commentCreateDTO']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CommentDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method creates a public or private (internal) comment on a customer request, with the comment visibility set by `public`. The user recorded as the author of the comment.  **[Permissions](#permissions) required**: User has Add Comments permission.  **Request limitations**: Customers can set comments to public visibility only.
     * Create request comment
     */
    createRequestComment(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.createRequestCommentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method deletes the feedback of request using it\'s `requestKey` or `requestId`  **[Permissions](#permissions) required**: User must be the reporter or an Atlassian Connect app.
     * Delete feedback
     */
    deleteFeedbackRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['requestIdOrKey'] == null) {
                throw new runtime.RequiredError('requestIdOrKey', 'Required parameter "requestIdOrKey" was null or undefined when calling deleteFeedback().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{requestIdOrKey}/feedback`.replace(`{${"requestIdOrKey"}}`, encodeURIComponent(String(requestParameters['requestIdOrKey']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * This method deletes the feedback of request using it\'s `requestKey` or `requestId`  **[Permissions](#permissions) required**: User must be the reporter or an Atlassian Connect app.
     * Delete feedback
     */
    deleteFeedback(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteFeedbackRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns an approval. Use this method to determine the status of an approval and the list of approvers.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get approval by id
     */
    getApprovalByIdRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getApprovalById().');
            }
            if (requestParameters['approvalId'] == null) {
                throw new runtime.RequiredError('approvalId', 'Required parameter "approvalId" was null or undefined when calling getApprovalById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/approval/{approvalId}`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"approvalId"}}`, encodeURIComponent(String(requestParameters['approvalId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ApprovalDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns an approval. Use this method to determine the status of an approval and the list of approvers.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get approval by id
     */
    getApprovalById(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getApprovalByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns all approvals on a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get approvals
     */
    getApprovalsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getApprovals().');
            }
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/approval`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOApprovalDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns all approvals on a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get approvals
     */
    getApprovals(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getApprovalsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns the contents of an attachment.  To return a thumbnail of the attachment, use [servicedeskapi/request/\\{issueIdOrKey\\}/attachment/\\{attachmentId\\}/thumbnail](./#api-rest-servicedeskapi-request-issueidorkey-attachment-attachmentid-thumbnail-get).  **[Permissions](#permissions) required:** For the issue containing the attachment:   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.
     * Get attachment content
     */
    getAttachmentContentRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getAttachmentContent().');
            }
            if (requestParameters['attachmentId'] == null) {
                throw new runtime.RequiredError('attachmentId', 'Required parameter "attachmentId" was null or undefined when calling getAttachmentContent().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/attachment/{attachmentId}`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters['attachmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Returns the contents of an attachment.  To return a thumbnail of the attachment, use [servicedeskapi/request/\\{issueIdOrKey\\}/attachment/\\{attachmentId\\}/thumbnail](./#api-rest-servicedeskapi-request-issueidorkey-attachment-attachmentid-thumbnail-get).  **[Permissions](#permissions) required:** For the issue containing the attachment:   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.
     * Get attachment content
     */
    getAttachmentContent(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAttachmentContentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Returns the thumbnail of an attachment.  To return the attachment contents, use [servicedeskapi/request/\\{issueIdOrKey\\}/attachment/\\{attachmentId\\}](#api-rest-servicedeskapi-request-issueidorkey-attachment-attachmentid-get).  **[Permissions](#permissions) required:** For the issue containing the attachment:   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.
     * Get attachment thumbnail
     */
    getAttachmentThumbnailRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getAttachmentThumbnail().');
            }
            if (requestParameters['attachmentId'] == null) {
                throw new runtime.RequiredError('attachmentId', 'Required parameter "attachmentId" was null or undefined when calling getAttachmentThumbnail().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/attachment/{attachmentId}/thumbnail`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters['attachmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Returns the thumbnail of an attachment.  To return the attachment contents, use [servicedeskapi/request/\\{issueIdOrKey\\}/attachment/\\{attachmentId\\}](#api-rest-servicedeskapi-request-issueidorkey-attachment-attachmentid-get).  **[Permissions](#permissions) required:** For the issue containing the attachment:   *  *Browse projects* [project permission](https://confluence.atlassian.com/x/yodKLg) for the project that the issue is in.  *  If [issue-level security](https://confluence.atlassian.com/x/J4lKLg) is configured, issue-level security permission to view the issue.
     * Get attachment thumbnail
     */
    getAttachmentThumbnail(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAttachmentThumbnailRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns all the attachments for a customer requests.  **[Permissions](#permissions) required**: Permission to view the customer request.  **Response limitations**: Customers will only get a list of public attachments.
     * Get attachments for request
     */
    getAttachmentsForRequestRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getAttachmentsForRequest().');
            }
            if (requestParameters['start'] == null) {
                throw new runtime.RequiredError('start', 'Required parameter "start" was null or undefined when calling getAttachmentsForRequest().');
            }
            if (requestParameters['limit'] == null) {
                throw new runtime.RequiredError('limit', 'Required parameter "limit" was null or undefined when calling getAttachmentsForRequest().');
            }
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/attachment`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOAttachmentDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns all the attachments for a customer requests.  **[Permissions](#permissions) required**: Permission to view the customer request.  **Response limitations**: Customers will only get a list of public attachments.
     * Get attachments for request
     */
    getAttachmentsForRequest(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAttachmentsForRequestRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns the attachments referenced in a comment.  **[Permissions](#permissions) required**: Permission to view the customer request.  **Response limitations**: Customers can only view public comments, and retrieve their attachments, on requests where they are the reporter or a participant whereas agents can see both internal and public comments.
     * Get comment attachments
     */
    getCommentAttachmentsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getCommentAttachments().');
            }
            if (requestParameters['commentId'] == null) {
                throw new runtime.RequiredError('commentId', 'Required parameter "commentId" was null or undefined when calling getCommentAttachments().');
            }
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:request.attachment:jira-service-management", "read:request.comment:jira-service-management"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/comment/{commentId}/attachment`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters['commentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOAttachmentDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns the attachments referenced in a comment.  **[Permissions](#permissions) required**: Permission to view the customer request.  **Response limitations**: Customers can only view public comments, and retrieve their attachments, on requests where they are the reporter or a participant whereas agents can see both internal and public comments.
     * Get comment attachments
     */
    getCommentAttachments(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCommentAttachmentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns a customer request.  **[Permissions](#permissions) required**: Permission to access the specified service desk.  **Response limitations**: For customers, only a request they created, was created on their behalf, or they are participating in will be returned.  **Note:** `requestFieldValues` does not include hidden fields. To get a list of request type fields that includes hidden fields, see [/rest/servicedeskapi/servicedesk/\\{serviceDeskId\\}/requesttype/\\{requestTypeId\\}/field](https://developer.atlassian.com/cloud/jira/service-desk/rest/api-group-servicedesk/#api-rest-servicedeskapi-servicedesk-servicedeskid-requesttype-requesttypeid-field-get)
     * Get customer request by id or key
     */
    getCustomerRequestByIdOrKeyRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getCustomerRequestByIdOrKey().');
            }
            const queryParameters = {};
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CustomerRequestDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns a customer request.  **[Permissions](#permissions) required**: Permission to access the specified service desk.  **Response limitations**: For customers, only a request they created, was created on their behalf, or they are participating in will be returned.  **Note:** `requestFieldValues` does not include hidden fields. To get a list of request type fields that includes hidden fields, see [/rest/servicedeskapi/servicedesk/\\{serviceDeskId\\}/requesttype/\\{requestTypeId\\}/field](https://developer.atlassian.com/cloud/jira/service-desk/rest/api-group-servicedesk/#api-rest-servicedeskapi-servicedesk-servicedeskid-requesttype-requesttypeid-field-get)
     * Get customer request by id or key
     */
    getCustomerRequestByIdOrKey(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerRequestByIdOrKeyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns a list of all the statuses a customer Request has achieved. A status represents the state of an issue in its workflow. An issue can have one active status only. The list returns the status history in chronological order, most recent (current) status first.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get customer request status
     */
    getCustomerRequestStatusRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getCustomerRequestStatus().');
            }
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/status`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOCustomerRequestStatusDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns a list of all the statuses a customer Request has achieved. A status represents the state of an issue in its workflow. An issue can have one active status only. The list returns the status history in chronological order, most recent (current) status first.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get customer request status
     */
    getCustomerRequestStatus(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerRequestStatusRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns all customer requests for the user executing the query.  The returned customer requests are ordered chronologically by the latest activity on each request. For example, the latest status transition or comment.  **[Permissions](#permissions) required**: Permission to access the specified service desk.  **Response limitations**: For customers, the list returned will include request they created (or were created on their behalf) or are participating in only.
     * Get customer requests
     */
    getCustomerRequestsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['searchTerm'] != null) {
                queryParameters['searchTerm'] = requestParameters['searchTerm'];
            }
            if (requestParameters['requestOwnership'] != null) {
                queryParameters['requestOwnership'] = requestParameters['requestOwnership'];
            }
            if (requestParameters['requestStatus'] != null) {
                queryParameters['requestStatus'] = requestParameters['requestStatus'];
            }
            if (requestParameters['approvalStatus'] != null) {
                queryParameters['approvalStatus'] = requestParameters['approvalStatus'];
            }
            if (requestParameters['organizationId'] != null) {
                queryParameters['organizationId'] = requestParameters['organizationId'];
            }
            if (requestParameters['serviceDeskId'] != null) {
                queryParameters['serviceDeskId'] = requestParameters['serviceDeskId'];
            }
            if (requestParameters['requestTypeId'] != null) {
                queryParameters['requestTypeId'] = requestParameters['requestTypeId'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOCustomerRequestDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns all customer requests for the user executing the query.  The returned customer requests are ordered chronologically by the latest activity on each request. For example, the latest status transition or comment.  **[Permissions](#permissions) required**: Permission to access the specified service desk.  **Response limitations**: For customers, the list returned will include request they created (or were created on their behalf) or are participating in only.
     * Get customer requests
     */
    getCustomerRequests(requestParameters = {}, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerRequestsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns a list of transitions, the workflow processes that moves a customer request from one status to another, that the user can perform on a request. Use this method to provide a user with a list if the actions they can take on a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get customer transitions
     */
    getCustomerTransitionsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getCustomerTransitions().');
            }
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/transition`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOCustomerTransitionDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns a list of transitions, the workflow processes that moves a customer request from one status to another, that the user can perform on a request. Use this method to provide a user with a list if the actions they can take on a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get customer transitions
     */
    getCustomerTransitions(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerTransitionsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method retrieves a feedback of a request using it\'s `requestKey` or `requestId`  **[Permissions](#permissions) required**: User has view request permissions.
     * Get feedback
     */
    getFeedbackRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['requestIdOrKey'] == null) {
                throw new runtime.RequiredError('requestIdOrKey', 'Required parameter "requestIdOrKey" was null or undefined when calling getFeedback().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{requestIdOrKey}/feedback`.replace(`{${"requestIdOrKey"}}`, encodeURIComponent(String(requestParameters['requestIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CSATFeedbackFullDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method retrieves a feedback of a request using it\'s `requestKey` or `requestId`  **[Permissions](#permissions) required**: User has view request permissions.
     * Get feedback
     */
    getFeedback(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getFeedbackRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns details of a customer request\'s comment.  **[Permissions](#permissions) required**: Permission to view the customer request.  **Response limitations**: Customers can only view public comments on requests where they are the reporter or a participant whereas agents can see both internal and public comments.
     * Get request comment by id
     */
    getRequestCommentByIdRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getRequestCommentById().');
            }
            if (requestParameters['commentId'] == null) {
                throw new runtime.RequiredError('commentId', 'Required parameter "commentId" was null or undefined when calling getRequestCommentById().');
            }
            const queryParameters = {};
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/comment/{commentId}`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"commentId"}}`, encodeURIComponent(String(requestParameters['commentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CommentDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns details of a customer request\'s comment.  **[Permissions](#permissions) required**: Permission to view the customer request.  **Response limitations**: Customers can only view public comments on requests where they are the reporter or a participant whereas agents can see both internal and public comments.
     * Get request comment by id
     */
    getRequestCommentById(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRequestCommentByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns all comments on a customer request. No permissions error is provided if, for example, the user doesn\'t have access to the service desk or request, the method simply returns an empty response.  **[Permissions](#permissions) required**: Permission to view the customer request.  **Response limitations**: Customers are returned public comments only.
     * Get request comments
     */
    getRequestCommentsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getRequestComments().');
            }
            const queryParameters = {};
            if (requestParameters['_public'] != null) {
                queryParameters['public'] = requestParameters['_public'];
            }
            if (requestParameters['internal'] != null) {
                queryParameters['internal'] = requestParameters['internal'];
            }
            if (requestParameters['expand'] != null) {
                queryParameters['expand'] = requestParameters['expand'];
            }
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/comment`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOCommentDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns all comments on a customer request. No permissions error is provided if, for example, the user doesn\'t have access to the service desk or request, the method simply returns an empty response.  **[Permissions](#permissions) required**: Permission to view the customer request.  **Response limitations**: Customers are returned public comments only.
     * Get request comments
     */
    getRequestComments(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRequestCommentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns a list of all the participants on a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get request participants
     */
    getRequestParticipantsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getRequestParticipants().');
            }
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/participant`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOUserDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns a list of all the participants on a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get request participants
     */
    getRequestParticipants(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRequestParticipantsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns all the SLA records on a customer request. A customer request can have zero or more SLAs. Each SLA can have recordings for zero or more \"completed cycles\" and zero or 1 \"ongoing cycle\". Each cycle includes information on when it started and stopped, and whether it breached the SLA goal.  **[Permissions](#permissions) required**: Agent for the Service Desk containing the queried customer request.
     * Get sla information
     */
    getSlaInformationRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getSlaInformation().');
            }
            const queryParameters = {};
            if (requestParameters['start'] != null) {
                queryParameters['start'] = requestParameters['start'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/sla`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOSlaInformationDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns all the SLA records on a customer request. A customer request can have zero or more SLAs. Each SLA can have recordings for zero or more \"completed cycles\" and zero or 1 \"ongoing cycle\". Each cycle includes information on when it started and stopped, and whether it breached the SLA goal.  **[Permissions](#permissions) required**: Agent for the Service Desk containing the queried customer request.
     * Get sla information
     */
    getSlaInformation(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSlaInformationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns the details for an SLA on a customer request.  **[Permissions](#permissions) required**: Agent for the Service Desk containing the queried customer request.
     * Get sla information by id
     */
    getSlaInformationByIdRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getSlaInformationById().');
            }
            if (requestParameters['slaMetricId'] == null) {
                throw new runtime.RequiredError('slaMetricId', 'Required parameter "slaMetricId" was null or undefined when calling getSlaInformationById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:jira-work"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/sla/{slaMetricId}`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))).replace(`{${"slaMetricId"}}`, encodeURIComponent(String(requestParameters['slaMetricId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.SlaInformationDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns the details for an SLA on a customer request.  **[Permissions](#permissions) required**: Agent for the Service Desk containing the queried customer request.
     * Get sla information by id
     */
    getSlaInformationById(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSlaInformationByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method returns the notification subscription status of the user making the request. Use this method to determine if the user is subscribed to a customer request\'s notifications.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get subscription status
     */
    getSubscriptionStatusRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling getSubscriptionStatus().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["read:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/notification`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.RequestNotificationSubscriptionDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method returns the notification subscription status of the user making the request. Use this method to determine if the user is subscribed to a customer request\'s notifications.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Get subscription status
     */
    getSubscriptionStatus(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubscriptionStatusRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method performs a customer transition for a given request and transition. An optional comment can be included to provide a reason for the transition.  **[Permissions](#permissions) required**: The user must be able to view the request and have the Transition Issues permission. If a comment is passed the user must have the Add Comments permission.
     * Perform customer transition
     */
    performCustomerTransitionRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling performCustomerTransition().');
            }
            if (requestParameters['customerTransitionExecutionDTO'] == null) {
                throw new runtime.RequiredError('customerTransitionExecutionDTO', 'Required parameter "customerTransitionExecutionDTO" was null or undefined when calling performCustomerTransition().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/transition`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.CustomerTransitionExecutionDTOToJSON)(requestParameters['customerTransitionExecutionDTO']),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This method performs a customer transition for a given request and transition. An optional comment can be included to provide a reason for the transition.  **[Permissions](#permissions) required**: The user must be able to view the request and have the Transition Issues permission. If a comment is passed the user must have the Add Comments permission.
     * Perform customer transition
     */
    performCustomerTransition(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.performCustomerTransitionRaw(requestParameters, initOverrides);
        });
    }
    /**
     * This method adds a feedback on an request using it\'s `requestKey` or `requestId`  **[Permissions](#permissions) required**: User must be the reporter or an Atlassian Connect app.
     * Post feedback
     */
    postFeedbackRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['requestIdOrKey'] == null) {
                throw new runtime.RequiredError('requestIdOrKey', 'Required parameter "requestIdOrKey" was null or undefined when calling postFeedback().');
            }
            if (requestParameters['cSATFeedbackFullDTO'] == null) {
                throw new runtime.RequiredError('cSATFeedbackFullDTO', 'Required parameter "cSATFeedbackFullDTO" was null or undefined when calling postFeedback().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{requestIdOrKey}/feedback`.replace(`{${"requestIdOrKey"}}`, encodeURIComponent(String(requestParameters['requestIdOrKey']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.CSATFeedbackFullDTOToJSON)(requestParameters['cSATFeedbackFullDTO']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.CSATFeedbackFullDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method adds a feedback on an request using it\'s `requestKey` or `requestId`  **[Permissions](#permissions) required**: User must be the reporter or an Atlassian Connect app.
     * Post feedback
     */
    postFeedback(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.postFeedbackRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method removes participants from a customer request.  **[Permissions](#permissions) required**: Permission to manage participants on the customer request.
     * Remove request participants
     */
    removeRequestParticipantsRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling removeRequestParticipants().');
            }
            if (requestParameters['requestParticipantUpdateDTO'] == null) {
                throw new runtime.RequiredError('requestParticipantUpdateDTO', 'Required parameter "requestParticipantUpdateDTO" was null or undefined when calling removeRequestParticipants().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/participant`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.RequestParticipantUpdateDTOToJSON)(requestParameters['requestParticipantUpdateDTO']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.PagedDTOUserDTOFromJSON)(jsonValue));
        });
    }
    /**
     * This method removes participants from a customer request.  **[Permissions](#permissions) required**: Permission to manage participants on the customer request.
     * Remove request participants
     */
    removeRequestParticipants(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.removeRequestParticipantsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * This method subscribes the user to receiving notifications from a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Subscribe
     */
    subscribeRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling subscribe().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/notification`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This method subscribes the user to receiving notifications from a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Subscribe
     */
    subscribe(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.subscribeRaw(requestParameters, initOverrides);
        });
    }
    /**
     * This method unsubscribes the user from notifications from a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Unsubscribe
     */
    unsubscribeRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['issueIdOrKey'] == null) {
                throw new runtime.RequiredError('issueIdOrKey', 'Required parameter "issueIdOrKey" was null or undefined when calling unsubscribe().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("OAuth2", ["write:servicedesk-request"]);
            }
            const response = yield this.request({
                path: `/rest/servicedeskapi/request/{issueIdOrKey}/notification`.replace(`{${"issueIdOrKey"}}`, encodeURIComponent(String(requestParameters['issueIdOrKey']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * This method unsubscribes the user from notifications from a customer request.  **[Permissions](#permissions) required**: Permission to view the customer request.
     * Unsubscribe
     */
    unsubscribe(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.unsubscribeRaw(requestParameters, initOverrides);
        });
    }
}
exports.RequestApi = RequestApi;
//# sourceMappingURL=RequestApi.js.map